module.exports = __webpack_public_path__ + "img/1449739242.83bb7381.jpg";